import classNames from 'classnames';
import Image, { Props as ImageProps } from '../Image';

interface Props {
  img: ImageProps;
  small?: boolean;
  shape?: 'circle' | 'rectangle';
}

function Avatar({
  img,
  small = false,
  shape = 'circle'
}: Props) {
  return (
    <div>
      <Image
        className={classNames([
          'object-cover object-center',
          small &&
            shape === 'circle' &&
            'h-9 w-9 rounded-full',
          small &&
            shape === 'rectangle' &&
            'h-9 w-9 rounded-xl',
          !small &&
            shape === 'circle' &&
            'h-16 w-16 rounded-full',
          !small &&
            shape === 'rectangle' &&
            'h-96 w-72 rounded-xl'
        ])}
        {...img}
      />
    </div>
  );
}

export default Avatar;
